import { SortTypeOption, TimeRangeOption } from './types';

export const MAX_UNIT_HISTORY_RESULTS = 3000;

export const last36HoursTimeRangeOption = {
    label: 'Last 36 Hours',
    value: 'LAST_36_HOURS',
} as const;

export const timeRangeOptions: TimeRangeOption[] = [
    {
        label: 'Last 12 Hours',
        value: 'LAST_12_HOURS',
    },
    { label: 'Last 16 Hours', value: 'LAST_16_HOURS' },
    { label: 'Last 24 Hours', value: 'LAST_24_HOURS' },
    last36HoursTimeRangeOption,
    { label: 'Last 48 Hours', value: 'LAST_48_HOURS' },
    { label: 'Custom', value: 'CUSTOM' },
];

export const newestFirstSortTypeOption = {
    label: 'Newest First',
    value: 'DATE_MOST_RECENT_TO_LEAST_RECENT',
} as const;

export const sortTypeOptions: SortTypeOption[] = [
    newestFirstSortTypeOption,
    { label: 'Oldest First', value: 'DATE_LEAST_RECENT_TO_MOST_RECENT' },
];
